import { getChannelDetailsApi } from '@/api/channel';
import { Message } from 'element-ui';

/**
 * 获取渠道详情
 * @param {string[]} channels 渠道号组成的数组
 * @returns {Promise<Array>} 渠道对象数组
 */
export function useGetChannelDetails(channels) {
  return new Promise((resolve, reject) => {
    getChannelDetailsApi({ channels })
      .then((res) => {
        if (!res.list.length) {
          Message.error(`渠道号${channels.join('、')}不存在`);
          reject();
          return;
        }
        resolve(res.list);
      })
      .catch((error) => {
        Message.error(`查询渠道号失败:${JSON.stringify(error)}`);
        reject(error);
      });
  });
}
